import React, { useEffect, useState } from 'react';
import { useRef } from 'react';
import Swal from 'sweetalert2';
import { Button } from 'react-bootstrap';
import { FaCopy, FaList } from 'react-icons/fa';
import authHeader from "../../../services/authheader";
import axios from "axios";
/*import './ReviewPdf.css';*/


function SummarySheetPdf(props) {
    const downloadPdf = () => {
        var urlProps = {
            url: process.env.REACT_APP_APIURL + "/Reports/SummarySheetPdf?parentId=" + props.id + "&parentTypeId=" + props.parentTypeId,
            name: "SummarySheet.pdf"
        };
        Swal.fire({
            title: 'Generating PDF',
            didOpen: () => {
                Swal.showLoading();
                axios.post(urlProps.url, null, { headers: authHeader(), responseType: 'arraybuffer' }).then((response) => {
                    var name = new String(response.headers['content-disposition']);
                    const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = downloadUrl;
                    link.setAttribute('download', urlProps.name);
                    document.body.appendChild(link);
                    Swal.close()
                    link.click();
                    link.remove();
                })
            },
            allowOutsideClick: false
        })
    }
    const downloadCombo = () => {
        var urlProps = {
            url: process.env.REACT_APP_APIURL + "/Reports/ApplicationSummarySheetComboPdf?parentId=" + props.id + "&parentTypeId=" + props.parentTypeId,
            name: "ComboSheet.pdf"
        };
        Swal.fire({
            title: 'Generating PDF',
            didOpen: () => {
                Swal.showLoading();
                axios.post(urlProps.url, null, { headers: authHeader(), responseType: 'arraybuffer' }).then((response) => {
                    var name = new String(response.headers['content-disposition']);
                    const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = downloadUrl;
                    link.setAttribute('download', urlProps.name);
                    document.body.appendChild(link);
                    Swal.close()
                    link.click();
                    link.remove();
                });
            },
            allowOutsideClick: false
        })
    }

    useEffect(() => {
        if (props.downloadSummarySheet != 0 && props.downloadSummarySheet % 2 == 0) {
            downloadPdf();
        }
    }, [props.downloadSummarySheet])

    useEffect(() => {
        if (props.downloadCombo != 0 && props.downloadCombo % 2 == 0) {
            downloadCombo();
        }
    }, [props.downloadCombo])

    const updateDownloadCallback = () => {
        props.setDownloadSummarySheet(props.downloadSummarySheet + 1);
    }
    const updateComboCallback = () => {
        props.setDownloadCombo(props.downloadCombo + 1);
    }

    return (
        <>
            <Button onClick={updateDownloadCallback} style={{ margin: '0 1em' }} variant='success'><FaList /> Download Summary Sheet</Button>
            <Button onClick={updateComboCallback} variant='warning'><FaCopy /> Download Combo</Button>
        </>
    );
}

export default SummarySheetPdf;